<template lang="html">
  <span>
    <img v-show="loaded" ref="imager" :style="styles" :alt="alt"/>
    <slot v-if="!loaded">
      <!-- TODO: show an inline image here -->
      loading
    </slot>
  </span>
</template>

<script>
export default {
  name: 'Imager',
  description: 'A wrapper around HTML img tag. Shows a loading spinner while the image is till loading',
  props: {
    src: {
      type: String,
      required: true,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    alt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loaded: false,
    };
  },
  methods: {
    onImageLoad() {
      this.loaded = true;
    },
  },
  mounted() {
    const image = this.$refs.imager;
    image.onload = this.onImageLoad;
    image.src = this.src;
  },
};
</script>

<style lang="scss" scoped>
  img:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Imager.vue